import React from 'react';
import './HeatmapDiagRasterConfigScreen.css';

const HeatmapDiagRasterConfigWarningSign = (props) => {
  return (
    <div id="HeatmapDiagRasterConfigScreen_MessageText_Box" className="HeatmapDiagRasterConfigScreen_MessageText_Box">
      <div id="HeatmapDiagRasterConfigScreen_MessageHeader" className="HeatmapDiagRasterConfigScreen_MessageHeader">
        Please note
      </div>
      <div id="HeatmapDiagRasterConfigScreen_MessageText" className="HeatmapDiagRasterConfigScreen_MessageText">
        The settings of the device selected will be stored then taken{' '}
        <span style={{ fontWeight: 'bold' }}> OUT OF SERVICE</span> during the Raster Scan. The device settings will be
        restored when the Diag Raster Scan is completed. The minimum setting for the Diag Raster Timeout is 5 minutes
        and the maximum setting for the Diag Raster Timeout is 15 minutes.
      </div>
    </div>
  );
};

export default HeatmapDiagRasterConfigWarningSign;
